export const initializeParticipantUserStats = () => ({
  type: 'INITIALIZE_PARTICIPANT_USER_STATS',
});

export const fetchParticipantUserStats = resp => ({
  type: 'FETCH_PARTICIPANT_USER_STATS',
  payload: resp,
});
